import React from "react"
import PropTypes from "prop-types"
import BillingStatusNotification from "./BillingStatusNotification"
import usePlanChangeState from "../hooks/usePlanChangeState"
function BillingStatus(props) {
  const { billing, orgId, showLink, className, uiSource } = props
  const { requestedPlanName } = usePlanChangeState(orgId)

  if (!billing || !orgId) {
    return null
  }

  return (
    <BillingStatusNotification
      organizationId={orgId}
      billing={billing}
      requestedPlanName={requestedPlanName}
      uiSource={uiSource}
      showLink={showLink}
      variant="SECONDARY"
      className={className}
    />
  )
}

BillingStatus.propTypes = {
  orgId: PropTypes.string,
  billing: PropTypes.object,
  showLink: PropTypes.bool,
  className: PropTypes.string,
  uiSource: PropTypes.string,
}

export default BillingStatus
